<template>
  <i
    v-if="!confirm"
    class="fa fa-plus xs-font update-text"
    @click="confirm = true"
  />
  <div v-else class="xs-font flex wrap align-center">
    <a class="m4" @click="confirm = false">Cancel</a>
    <input
      v-if="type == 'object'"
      class="xs-input"
      type="text"
      v-model="inputs.key"
      placeholder="Key"
    />
    <input
      class="xs-input"
      type="text"
      v-model="inputs.value"
      placeholder="Value"
    />
    <button class="update" @click="add(); confirm = false">Add</button>
  </div>
</template>
<script>
export default {
  props: {
    type: { type: String },
    obj: { type: [Object, Array] },
    fn: { type: Object }, // {command, method, type, data string to parse ($_)}
  },
  data() {
    return {
      confirm: false,
      inputs: {},
    };
  },
  methods: {
    add() {
      if (Array.isArray(this.obj)) {
        this.obj.push(this.type === 'object' ? {[this.inputs.key]: this.inputs.value} : this.inputs.value);
      } else {
        this.$set(this.obj, this.inputs.key, this.inputs.value);
      }
      let data = this.$_.get(this, this.fn.obj);
      this.$store[this.fn.command](this.fn.method, {
        type: this.fn.type,
        data,
      })
    },
  },
};
</script>